import Zone from '@/models/zone'

export default {
  zones: [],
  zone: new Zone().getObject(),
  icon: null
}
